import { logoutOfCMS } from "@/helpers/Auth";
import { BasicButton, IconLibrary, ThriveIcon } from "thrive-components";

const SingleFactorExternalInfoContainer = () => (
  <div className="passkey-set-up-panel">
    <div className="top-panel">
      <ThriveIcon
        className="passkey-set-up-icon"
        iconName={IconLibrary.LOCK}
        color="var(--thriveCharcoal)"
        sizeInPx="16"
      />

      <span className="boldened-header">2FA Required</span>
    </div>

    <div className="passkey-users-explainer-text">
      You need to login with a two factor authentication method before you can manage
      Passkey settings. Check with your login provider for more information on how to do this.
    </div>

    <BasicButton
      className='create-passkey-button'
      content={
        <>
          <ThriveIcon
            iconName={IconLibrary.LOGOUT}
            color='var(--thriveCharcoal)'
            sizeInPx='12'
          />
          {'Log Out'}
        </>
      }
      onButtonClick={logoutOfCMS}
      ariaLabel={'Log Out'}
    />
  </div>
);

export default SingleFactorExternalInfoContainer
